import $ from "jquery";
import { Klass, u_, csl } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./klass.VuwStepForm";
import "./klass.VuwFileset.extend";

import callbacks from "./assets/jbForm.callbacks";
import ajaxErrorCallback from "./assets/jbForm.ajaxErrorCallback";
import showPrompt from "./assets/jbForm.showPrompt";
import getDefaultSheetProp from "./assets/jbForm.getDefaultSheetProp";
import initForm from "./assets/jbForm.initForm";
import wysiwyg from "./assets/jbForm.wysiwyg";
import nextStepCallBacks from "./assets/jbForm.nextStepCallBacks";
import fileUploaderCallbacks from "./assets/jbForm.fileUploaderCallbacks";

/**********************************
 * VuwJbForm (extends VuwStepForm)
 * @options
 * - {WebAppBase} app
 * - {Boolean} autoInit
 * - {Boolean} REST: trueの場合、REST APIとの通信用の処理となる
 * - {Function} onUpdate: フォームの値が更新された後のコールバック
 * - {Function} onValidate: jsValidate実行時のコールバック
 * - {Function} onCopyToConfirmSheet: 確認シートへ値がコピーされる際のコールバック
 * - {Function} onSubmitSuccess: submit成功コールバック
 * - {Object} fileFieldCallbacks: ファイル項目に関するコールバック集
 **********************************/
vuwer.appendKlass("VuwJbForm", {
	autoInit: true,
	REST: false,
	configModeValue: "config",
	
	...callbacks,
	...ajaxErrorCallback,
	...showPrompt,
	...getDefaultSheetProp,
	...initForm,
	...wysiwyg,
	...nextStepCallBacks,
	...fileUploaderCallbacks,
	
	// [constructor]
	_initialize(opt) {
		!u_.isObject(opt) && (opt = {});
		
		// for legacy
		if(!opt.app && opt.wAB) {
			opt.app = opt.wAB;
			delete opt.wAB;
		}
		
		if( !( opt.app instanceof Klass("WebAppBase") ) ) {
			throw new TypeError("'app' must be an instance of WebAppBase.");
		}
		
		if(!opt.ACTION_URL && opt.app.ACTION_URL) {
			// ACTION_URL値をappと同期
			opt.ACTION_URL = opt.app.ACTION_URL;
		}
		
		if( u_.isFunction(opt.onReadyFirst) ) {
			// onReadyFirstが指定されていたら退避
			this._onReadyFirst = opt.onReadyFirst;
			delete opt.onReadyFirst;
		}
		
		if( u_.hasProperty(opt, "errorCallbacks") ) {
			// errorCallbacksが指定されている場合
			if( u_.isObject(opt.errorCallbacks) ) {
				opt.errorCallbacks = { ...this.errorCallbacks, ...opt.errorCallbacks };
			} else {
				delete opt.errorCallbacks;
			}
		}
		
		if( u_.hasProperty(opt, "fileFieldCallbacks") ) {
			// fileFieldCallbacksが指定されている場合
			if( u_.isObject(opt.fileFieldCallbacks) ) {
				opt.fileFieldCallbacks = { ...this.fileFieldCallbacks, ...opt.fileFieldCallbacks };
			} else {
				delete opt.fileFieldCallbacks;
			}
		}
		
		if( Klass("VuwJbForm").parent._initialize.call(this, opt) ) {
			this.execModeValues.config = this.configModeValue;
			
			// id prefix
			u_.isString(opt.inputIdPrefix) || ( this.inputIdPrefix = this.name.replace(/form$/i, "") );
			
			// promise (if autoInit is true, exec loadConfig.)
			this._promise = !!this.autoInit ? this.loadConfig() : Promise.resolve();
			return this;
		} else {
			return false;
		}
	},
	
	async onReadyFirst($self) {
		if(!$self) {
			return false;
		}
		
		// [autoInit]
		await this._promise;
		if(this.autoInit) {
			await this.initForm();
		}
		
			// [onReadyFirst]
		return !u_.isFunction(this._onReadyFirst) || this._onReadyFirst(this.$self);
	},
	
	// アラート表示
	async alert(msg, cb) {
		if( u_.isFunction(this.app.alert) ) {
			return this.app.alert.apply(this.app, arguments);
		} else {
			if( u_.isString(msg) && msg ) {
				alert( u_.replaceHtmlTag( msg.replace(/<br\/?>/g, "\n") ) );
			}
			return !u_.isFunction(cb) || cb();
		}
	},
	
	showLoading(methodName) {
		Klass("VuwJbForm").parent.showLoading.call(this, methodName);
		
		if( u_.isFunction(this.app.showLoading) ) {
			return this.app.showLoading(methodName);
		}
	},
	
	hideLoading(methodName) {
		Klass("VuwJbForm").parent.hideLoading.call(this, methodName);
		
		if( u_.isFunction(this.app.hideLoading) ) {
			return this.app.hideLoading(methodName);
		}
	},
	
	/*----------------
	* 設定情報のセッター
	* @return this
	*/
	setConfig(config) {
		if( !u_.isObject(config) ) {
			throw new TypeError("arguments[0] must be object.");
		}
		
		if(!config.ajaxTimeoutTime && this.app.config.ajaxTimeoutTime) {
			config.ajaxTimeoutTime = this.app.config.ajaxTimeoutTime;
		}
		
		if(config.fileDir) {
			config.fileDir = config.fileDir.replace(/^\{root\}/, this.app._relativePath);
		}
		
		if( u_.isObject(config.form) ) {
			Object.assign(config, config.form);
			delete config.form;
		}
		
		Object.assign(this.config, config);
		
		// for wysiwyg
		this.wysiwyg.ready.call(this);
		
		return this;
	},
	
	// [override]
	_getKeyOfValForField(vuwField, val) {
		let k;
		if(vuwField.inpType === "wysiwyg") {
			k = `${vuwField.paramKey}_delta`;
			if( !u_.hasProperty(val, k) ) {
				if( u_.hasProperty(val, vuwField.paramKey) ) {
					k = vuwField.paramKey;
				} else {
					k = undefined;
				}
			}
		} else {
			k = Klass("VuwJbForm").parent._getKeyOfValForField.apply(this, arguments);
		}
		return k;
	},
	
	// [override]
	_sendRequest(method, ajaxSetting, cb) {
		// for fileUploader
		const vuwForm = u_.isObject(this.execModeValues) ? this : this.container.getForm();
		
		if(vuwForm.REST && !ajaxSetting.url) {
			const k = method.replace(/^load|^aRequest|Upload$/g, "").toLowerCase();
			
			if( u_.hasProperty(vuwForm.execModeValues, k) ) {
				u_.isObject(ajaxSetting.data) && ( delete ajaxSetting.data[vuwForm.execModeParamName] );
				ajaxSetting.url = `${this.ACTION_URL}/${vuwForm.execModeValues[k]}`;
			}
		}
		
		return Klass("VuwJbForm").parent._sendRequest.call(this, method, ajaxSetting, cb);
	},
	
	/*----------------
	* 設定情報のロード
	* @param reqData {object} リクエストデータ
	**/
	async loadConfig(reqData) {
		const method = "loadConfig";
		
		const data = {};
		data[this.execModeParamName] = this.execModeValues.config;
		reqData = Object.assign(data, u_.isObject(reqData) ? reqData : {});
		
		// [send request]
		return this._sendRequest(method, {
			data: reqData
		}, (err, res) => {
			if(!err) {
				csl.log.purple(`${this.getAddress()}: ${method}`, res.config);
				this.setConfig(res.config);
			}
		});
	},
	
	/*----------------
	* [override] setVal
	**/
	setVal(val, callback) {
		return Klass("VuwJbForm").parent.setVal.call(this, val, async () => {
			// wysiwyg
			if(
				Array.isArray(this.wysiwyg.params) &&
				u_.isObject(this.wysiwyg.params._map)
			) {
				this.wysiwyg.params.forEach(pk => {
					const vuwField = this.wysiwyg.params._map[pk];
					!!vuwField && vuwField.clearHistory();
				});
			}
			
			// exec callback
			const ret = !u_.isFunction(callback) || await callback.call(this);
			if( u_.isFunction(this.onUpdate) ) {
				this.onUpdate(this.getVal(), this.config, ret);
			}
		});
	},
	
	/*----------------
	* [override] clearVal
	**/
	clearVal() {
		Klass("VuwJbForm").parent.clearVal.apply(this, arguments);
		u_.isFunction(this.onUpdate) && this.onUpdate.call(this, this.getVal(), this.config);
		return this;
	},
	
	/*----------------
	* シートの入力リストをコピー(confirmシート用)
	**/
	_copySheetFrom(vuw) {
		if( !( vuw instanceof Klass("VuwSheet") ) ) {
			throw new TypeError("arguments[0] must be VuwSheet instance");
		}
		
		const $clone = vuw.$inpsList.clone();
		
		// 入力要素を表示用に置換
		$clone.find(".vuw-field").each((i, elm) => {
			const $copiedField = $(elm);
			if(!elm.id) {
				csl.warn(
					"_copySheetFrom",
					`The field element has no id: ${$copiedField.data("name")}`
				);
				$copiedField.remove();
				return true;
			}
			
			const fieldId = elm.id;
			elm.id = `{elm.id}_copied`;
			
			// コピー元のフィールドを取得
			const vuwField = $.data(document.getElementById(fieldId), "vuw");
			if(!vuwField) {
				csl.warn("_copySheetFrom", `src field isn't found: ${$copiedField.data("name")}`);
				$copiedField.remove();
				return true;
			}
			
			$copiedField.replaceWith( vuwField.getCopiedElement() );
		});
		
		$clone.find([
			// 必須項目表示の削除
			".required",
			// limit表示の削除
			".limit",
			// ボタンの削除
			".btn",
			// hidden項目の削除
			"input[type='hidden']"
		].join(",")).remove();
		
		const $copy = $("<div/>").addClass("copied-sheet").attr("data-sheet", vuw.name).append($clone);
		
		if( u_.isFunction(this.onCopyToConfirmSheet) ) {
			this.onCopyToConfirmSheet.call(this, $copy, this.config);
		}
		
		return $copy;
	}
}, "VuwStepForm");
